import React from "react";
import { Typography, Box } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/reducers";
import { IFormCategoryModel, ILookupItemModel } from "../../types/types";
import { useQuery } from "@tanstack/react-query";
import { AppDispatch } from "../../store/store";
import {
  getHiddenFields,
  hideField,
  showField,
} from "../../store/modules/hiddenFields/hiddenFieldActions";
import { saveCoAgentFilter } from "../../store/modules/coAgentFilter/coAgentFilterActions";
import { clearCoAgentFilter } from "../../store/modules/coAgentFilter/coAgentFilterSlice";
import LoadingDialog from "../Dialogs/LoadingDialog";
import SettingsToggleRow from "./SettingsToggleRow";

interface FieldVisibilitySettingsProps {}

const FieldVisibilitySettings: React.FC<
  FieldVisibilitySettingsProps
> = ({}) => {
  const { data, userData } = useSelector(
    (state: RootState) => state.commonData,
  );

  const { loading, error, hiddenFields, loaded, isToggling } = useSelector(
    (state: RootState) => state.hiddenFields,
  );

  const dispatch = useDispatch<AppDispatch>();

  useQuery({
    queryKey: ["userCustomData"],
    queryFn: () => {
      // if (!userDataLoaded) {
      dispatch(getHiddenFields());
      return Promise.resolve(null);

      // }
    },
    refetchOnWindowFocus: false,
    enabled: !loaded,
  });

  const handleToggle = (
    item: ILookupItemModel | undefined,
    category: IFormCategoryModel,
  ) => {
    if (!item) {
      // Hiding the field
      dispatch(hideField(category.id!, category.internalName!));

      // Clear co-agent filter if hiding the coAgent category
      if (category.internalName === "coAgent") {
        dispatch(clearCoAgentFilter());
      }
    } else {
      dispatch(showField(item.id!));
    }
  };

  return (
    <>
      <LoadingDialog open={loading || isToggling} />
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.04)",
          p: { xs: 2, md: 4 },
          mb: 1,
          minHeight: 400,
        }}
      >
        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}
        {data?.categories?.map((field) => {
          const lookup = hiddenFields?.find(
            (f) => f.name === field.internalName,
          );
          return (
            <SettingsToggleRow
              key={field.id}
              label={field.name ?? ""}
              checked={!lookup}
              onChange={() => handleToggle(lookup, field)}
            />
          );
        })}
      </Box>
    </>
  );
};

export default FieldVisibilitySettings;
